import React, {useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Grid, IconButton, Paper, Typography, Button, Box, CircularProgress } from '@material-ui/core';
import { DataGrid, GridColumns, GridSortModel, GridFilterModel, GridToolbar } from '@material-ui/data-grid';
import { FieldType } from "../data-management/productsSlice";
import { useSelectedOrganisationId } from "../hooks/useSelectedOrganisationId";
import axios from "axios";
import { useToken } from '../hooks/useToken';
import PrintIcon from '@material-ui/icons/Print';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
    root: {
      margin: 0,
      minHeight: '90vh',
      '& .MuiDataGrid-row.Mui-even': {
        backgroundColor: 'rgba(196, 196, 196, 0.2);',
      },
    },
    paper: {
      padding: '40px 50px 52px',
    },
    wrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    filterItem: {
      flexGrow: 1,
      marginRight: theme.spacing(20),
    },
    itemFlexGrow: {
      flexGrow: 1,
      minHeight: 400,
      padding: '50px',
    },
    statusRow: {
      backgroundColor: '#DEFFBD',
      paddingLeft: '6px',
      paddingRight: '6px'
    }
}));

type Category = {
  id: string | number
  name: string
  fields: FieldType[],
  description: string|undefined,
}

export const ProductCategoryList = () => {

    const {t} = useTranslation();
    const classes = useStyle();
    const orgId = useSelectedOrganisationId();
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState<Category[] | undefined>(undefined);
    const token = useToken();

    const refreshTable = function(){
        if(orgId != -1){
            setLoading(true);
            axios
            .get(`${process.env.REACT_APP_SERVER_URL}/categories`, {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                setItems(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err.message);
            });
        }
    }

    useEffect(() => {
        refreshTable();
    }, [orgId]);

    const columns: GridColumns = [
        {
            field: 'id',
            headerName: t('product_category_list_column_id'),
            type: 'number',
            align: 'left',
            headerAlign: 'left',
            flex: 0.40
        },
        {
            field: 'name',
            headerName: t('product_category_list_column_name'),
            flex: 0.75,
            type: 'string',
        },
        {
            field: 'show',
            headerName: '',
            sortable: false,
            resizable: false,
            editable: false,
            hideSortIcons: true,
            filterable: false,
            flex: 0.75,
            disableColumnMenu: true,
            renderHeader: () => (
              <div />
            ),
            renderCell: (params) => (
              <Link className={classes.wrapper} to={`/edit-product-categories/${params.id}`}>
                  <EditIcon style={{ fill: '#535353' }}></EditIcon>
                  <Typography style={{color: "#535353", marginLeft: "4px"}}>
                      {t('product_category_edit_button')}
                  </Typography>
              </Link>
            ),
        },
    ];

    const rows = items ?? [];

    return (
        <>
            <Grid container direction={'column'} className={classes.root}>
                <Grid item>
                    <Paper elevation={0} className={classes.paper}>
                    <div className={classes.wrapper}>
                        <Typography className={classes.filterItem} variant="h4">
                        {t('product_category_list_title_text')}
                        </Typography>
                    </div>
                    </Paper>
                </Grid>
                <Grid item className={classes.itemFlexGrow}>
                    <Paper>
                        {loading ? <Grid container justify={'center'}><Box p={2}><CircularProgress/></Box></Grid> :
                            <div style={{ minHeight: 300, width: '100%' }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={10}
                                autoHeight
                                disableSelectionOnClick
                                disableColumnSelector
                                components={{
                                Toolbar: GridToolbar,
                                }}
                            />
                            </div> }
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}